import type { MutationOptions, QueryClient } from '@tanstack/react-query';
import { reviewAPIClient } from '../reviewAPIClient';
import { REVIEW_MUTATION_KEYS } from './keys';
import type { CreateReviewRequest, CreateReviewResponse } from './types';

export const REVIEW_MUTATIONS = {
  createReview: (queryClient: QueryClient): MutationOptions<CreateReviewResponse, Error, CreateReviewRequest> => ({
    mutationKey: REVIEW_MUTATION_KEYS.createReview(),
    mutationFn: (params: CreateReviewRequest) => reviewAPIClient.createReview(params),
  }),
};
